import { Link } from "react-router-dom";
import { UserPlus, MessageCircle, Share2, ChevronRight, Trophy } from "lucide-react";
import { useGrowth, inviteMsg } from "@/lib/growth";
import { openShare, getShareUrl } from "@/lib/share";

const whatsapp = async () => {
  const w = window.open("", "_blank");
  const url = await getShareUrl({ kind: "invite" }).catch(() => `${window.location.origin}/registrieren`);
  const href = `https://api.whatsapp.com/send?text=${encodeURIComponent(`${inviteMsg} ${url}`)}`;
  if (w) w.location.href = href; else window.location.href = href;
};

export function InviteFeedCard() {
  const g = useGrowth();
  if (!g) return null;
  const nxt = g.next;
  const prev = [...g.tiers].reverse().find((t) => t.reached)?.n || 0;
  const pct = nxt ? Math.round(((g.count - prev) / (nxt.n - prev)) * 100) : 100;
  return (
    <section className="relative overflow-hidden rounded-[26px] menu-hero text-white p-4 sm:p-5 shadow-xl shadow-rose-200/70 fade-rise" data-testid="invite-feed-card">
      <span className="absolute -right-8 -top-10 w-36 h-36 rounded-full bg-white/10" aria-hidden />
      <Link to="/einladen" className="relative flex items-center gap-3" data-testid="invite-feed-open">
        <span className="w-12 h-12 shrink-0 rounded-2xl bg-white/20 ring-1 ring-white/30 flex items-center justify-center"><UserPlus className="w-6 h-6" /></span>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] font-extrabold uppercase tracking-[0.22em] text-white/80">Lass die Community wachsen</p>
          <p className="font-display font-extrabold text-base sm:text-lg leading-snug" data-testid="invite-feed-title">
            {nxt ? <>Noch {nxt.n - g.count} bis „{nxt.title}“ <span className="text-amber-200">+{nxt.points}</span></> : <>Legende! {g.count} Freunde eingeladen</>}
          </p>
        </div>
        <span className="shrink-0 inline-flex items-center gap-1 text-xs font-bold bg-white/15 rounded-full px-2.5 py-1" data-testid="invite-feed-count"><Trophy className="w-3.5 h-3.5 text-amber-200" />{g.count}</span>
        <ChevronRight className="w-4 h-4 text-white/70 shrink-0" />
      </Link>
      <div className="relative mt-3 h-2 rounded-full bg-white/20 overflow-hidden"><div className="h-full rounded-full bg-gradient-to-r from-amber-200 to-white transition-[width] duration-700" style={{ width: `${Math.max(6, pct)}%` }} data-testid="invite-feed-progress" /></div>
      <div className="relative mt-3 grid grid-cols-2 gap-2">
        <button onClick={whatsapp} data-testid="invite-feed-whatsapp" className="h-11 rounded-full bg-white text-emerald-600 font-extrabold text-sm inline-flex items-center justify-center gap-2 active:scale-95 transition-transform"><MessageCircle className="w-4 h-4" /> WhatsApp</button>
        <button onClick={() => openShare({ kind: "invite", title: "Freunde einladen", msg: inviteMsg })} data-testid="invite-feed-share" className="h-11 rounded-full bg-white/15 ring-1 ring-white/40 font-extrabold text-sm inline-flex items-center justify-center gap-2 active:scale-95 transition-transform"><Share2 className="w-4 h-4" /> Teilen</button>
      </div>
    </section>
  );
}
